/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Campaign/Enums/WhatsAppAiActivityState.php */
export const whatsAppAiActivityState = {
	idle: 'idle',
	queued: 'queued',
	thinking: 'thinking',
} as const

/** @see backend/nexus/modules/Campaign/Enums/WhatsAppAiActivityState.php */
export type WhatsAppAiActivityState = (typeof whatsAppAiActivityState)[keyof typeof whatsAppAiActivityState]
